import React from "react";
import { motion } from "framer-motion";
import { WHY_US, IMG } from "../lib/content";

export default function WhyChooseUs() {
  return (
    <section data-testid="why-us" className="relative py-24 md:py-32 lg:py-40 bg-white text-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 text-[#B8965A]">
            <span className="block w-8 h-px bg-[#C9A86A]" />
            <span className="text-[11px] uppercase tracking-[0.3em]">Why Reflex</span>
          </div>
          <h2 className="mt-6 font-display-bold text-4xl md:text-5xl lg:text-6xl tracking-tighter">
            A quieter kind of <span className="font-serif-italic font-light text-[#B8965A]">excellence.</span>
          </h2>
          <p className="mt-6 max-w-md text-[#525252] leading-relaxed">
            We don't do rush jobs and we don't do shortcuts. Every project is treated
            like a piece of architecture — because that's what your stone is.
          </p>

          <div className="mt-12 hidden lg:block img-zoom-wrap">
            <img
              src={IMG.cleaningProcess}
              alt="Diamond restoration process — calibrated honing in progress"
              className="w-full h-[480px] object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-black/10">
          {WHY_US.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="bg-white p-8 md:p-10"
              data-testid={`why-card-${i}`}
            >
              <w.icon className="w-6 h-6 text-[#B8965A]" strokeWidth={1.4} />
              <h3 className="mt-6 font-display-bold text-xl tracking-tight">{w.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#525252]">{w.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
